import { privateClient } from '@lidea/shared/data-access/core';
import {
  Heatmap,
  ListIndexes,
  Measure,
  Measures,
  Zoning,
} from '@lidea/shared/util/types';

export const zoningApi = {
  getImageryIndexes: () => {
    return privateClient.get('list_indexes/').json<ListIndexes>();
  },
  getHeatmaps: (params: { plotId: number; imageryIndex: string }) => {
    return privateClient
      .get(`plots/${params.plotId}/heatmaps/`, {
        searchParams: { type: params.imageryIndex },
      })
      .json<Heatmap[]>();
  },
  getZoning: (analysisId: number) => {
    return privateClient.get(`analysis/${analysisId}/zoning`).json<Zoning>();
  },
  generateZoning: (
    imageryIndex: string,
    imageDate: string,
    analysisId: number,
    zoneNumber: string
  ) => {
    const searchParams: any = {
      date: imageDate,
      analysis: analysisId.toString(),
      type: imageryIndex,
    };

    if (zoneNumber !== '-1') {
      searchParams.zone = zoneNumber;
    }

    return privateClient
      .get('zonage', {
        searchParams,
        timeout: 180000, // zonage can exceed ky's default 10s
      })
      .json<Zoning>();
  },
  getMeasures: (analysisId: number) => {
    return privateClient
      .get(`analysis/${analysisId}/measures/`)
      .json<Measures>();
  },
  getMeasure: (measureId: number) => {
    return privateClient.get(`measures/${measureId}/`).json<Measure>();
  },
  updateMeasure: async (props: {
    id: number;
    data: { [key: string]: number | string | null };
  }) => {
    const response = await privateClient.patch(`measures/${props.id}/`, {
      json: props.data,
    });

    try {
      return await response.json<Measure>();
    } catch {
      // PATCH may have succeeded even when the response body is not parseable.
      return zoningApi.getMeasure(props.id);
    }
  },
  uploadCropPicture: (props: UploadPictureDto) => {
    if (!props.picture) {
      return Promise.reject(
        new Error('Crop picture File is required for upload')
      );
    }
    const formData = new FormData();
    formData.append('image', props.picture);
    formData.append('field', props.field);

    return privateClient
      .post(`measures/${props.measureId}/upload/`, { body: formData })
      .json();
  },
};

export type UploadPictureDto = {
  measureId: number;
  field: string;
  /** In-memory file for the current session; may be absent after restore. */
  picture?: File;
  /** Durable IDB key — survives app kill; used to rehydrate `picture`. */
  pictureId?: string;
};
